import { userConstants } from '../constants/login.constants';

function documentTimeline(state = {}, action) {
    switch (action.type) {
        case userConstants.DOCUMENTTIMELINE_REQUEST:
            return {
                loading: true
            };
        case userConstants.DOCUMENTTIMELINE_SUCCESS:
            return {
                items: action.documentTimeline
            };
        case userConstants.DOCUMENTTIMELINE_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}
export default documentTimeline;
